import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Role\UpdateRoleController::__invoke
* @see app/Http/Controllers/Role/UpdateRoleController.php
* @route '/api/role/{role}'
*/
const UpdateRoleController = (args: { role: string | { id: string } } | [role: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: UpdateRoleController.url(args, options),
    method: 'put',
})

UpdateRoleController.definition = {
    methods: ["put"],
    url: '/api/role/{role}',
} satisfies RouteDefinition<["put"]>

/**
* @see \App\Http\Controllers\Role\UpdateRoleController::__invoke
* @see app/Http/Controllers/Role/UpdateRoleController.php
* @route '/api/role/{role}'
*/
UpdateRoleController.url = (args: { role: string | { id: string } } | [role: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { role: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { role: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            role: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        role: typeof args.role === 'object'
        ? args.role.id
        : args.role,
    }

    return UpdateRoleController.definition.url
            .replace('{role}', parsedArgs.role.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Role\UpdateRoleController::__invoke
* @see app/Http/Controllers/Role/UpdateRoleController.php
* @route '/api/role/{role}'
*/
UpdateRoleController.put = (args: { role: string | { id: string } } | [role: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: UpdateRoleController.url(args, options),
    method: 'put',
})

export default UpdateRoleController